import { cn } from '../../lib/cn';

/**
 * Icon wrapper component for consistent icon styling across the app.
 * Uses Lucide React icons - import icons directly from 'lucide-react'.
 *
 * @example
 * import { FileText, Link, Video } from 'lucide-react';
 * import { Icon } from '../components/ui';
 *
 * <Icon icon={FileText} size="md" />
 * <Icon icon={Link} size="lg" className="text-blue-500" />
 */

const sizes = {
  xs: 'w-3 h-3',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
  xl: 'w-8 h-8',
  '2xl': 'w-10 h-10',
};

export default function Icon({
  icon: IconComponent,
  size = 'md',
  className,
  strokeWidth = 1.5,
  ...props
}) {
  if (!IconComponent) return null;

  return (
    <IconComponent
      className={cn(sizes[size] || sizes.md, className)}
      strokeWidth={strokeWidth}
      {...props}
    />
  );
}

// Re-export commonly used icons for convenience
export {
  FileText,
  Link as LinkIcon,
  Video,
  Type,
  Upload,
  Image,
  File,
  ChevronLeft,
  ChevronRight,
  Plus,
  X,
  Check,
  Search,
  Settings,
  User,
  LogOut,
  Home,
  BookOpen,
  GraduationCap,
  PenTool,
  MessageSquare,
  BarChart3,
  Trash2,
  Edit3,
  Eye,
  EyeOff,
  ExternalLink,
  Copy,
  Download,
  RefreshCw,
  AlertCircle,
  Info,
  CheckCircle,
  XCircle,
} from 'lucide-react';
